import React, { forwardRef } from 'react';

// Design-system Button (REZ-1309). Renders the rr-btn classes from src/theme/components.css.
// variant: primary | secondary | success | danger | warning | ghost
// size: sm (control-sm, 31px) | md (38px) | lg (48px)
// Any native button prop (id, disabled, onClick, aria-*) passes through, so popover and
// tooltip targets that look buttons up by id keep working.
const Button = forwardRef(
  ({ variant = 'primary', size = 'md', icon = null, className = '', type = 'button', children, ...rest }, ref) => {
    const classes = [
      'rr-btn',
      variant !== 'primary' ? `rr-btn--${variant}` : null,
      size !== 'md' ? `rr-btn--${size}` : null,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button ref={ref} type={type} className={classes} {...rest}>
        {icon}
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
